import { useSelector } from 'react-redux'
import { AppState } from '../../index'

export const useAccessToken = (): string | undefined => {
  return useSelector<AppState, AppState['user']['accessToken']>((state) => {
    return state.user.accessToken
  })
}
